import { Divider, Grid } from '@material-ui/core'
import styled from 'styled-components'

interface IDividerHorizontal {
  marginTop?: number
}

export const Wrapper = styled(Grid)`
  margin-bottom: 7.4rem;
`

export const Fieldset = styled.div`
  margin-bottom: 1.6rem;
`

export const GridHeader = styled(Grid)`
  display: inline-flexbox;
  padding: 0.5rem 0 0.7rem 0;
`

export const GridTitle = styled(Grid)`
  display: block;
  padding: 0.5rem 0 1rem 0;
`
export const GridTitleSIF = styled(Grid)`
  display: block;
  padding: 0.5rem 0 1rem 2rem;
`

export const BoxTitle = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.4rem;
  font-weight: 600;
  padding-bottom: 1rem;
`

export const GridFields = styled(Grid)`
  display: flex;
  margin: -16px;
  width: calc(100% + 24px);
  flex-direction: row;
`

export const GridFieldsPhoto = styled(Grid)`
  display: flex;
  margin: 0;
  width: calc(100% + 24px);
  flex-direction: row;
`

export const GridPhoto = styled(Grid)`
  display: flex;
  margin: 0 1.6rem;
  width: calc(100% + 24px);
  flex-direction: row;
`

export const FullGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 5px 25px #0000000d;
  border-radius: 1.2rem;
  padding: 2.4rem;
`

export const GridInputs = styled(Grid)`
  display: flex;
`

export const GridButtonsAdd = styled(Grid)`
  align-self: center;
  margin-top: 1.6rem;
  text-align: right;
  > button {
    width: 22rem;
  }
`

export const GridButtonsMap = styled(Grid)`
  align-self: baseline;
`

export const GridButtons = styled(Grid)`
  align-self: center;
  text-align: end;
  margin: 3.2rem 0;

  button {
    margin: 0;
  }

  button + button {
    margin-left: 2.4rem;
  }
`

export const GridInput = styled(Grid)``

export const CardPhoto = styled.div`
  background-color: #f7f9fd;
  border-radius: 0.8rem;
  width: 100%;
  margin: 0 1.6rem;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0.8rem;
  height: 16.8rem;
`
export const CardPhotosIndustry = styled.div`
  background-color: #f7f9fd;
  border-radius: 0.8rem;
  width: 100%;
  margin: 1.6rem;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0.8rem;

  display: grid;
`

export const DividerVertical = styled(Divider)`
  background-color: #f2f3f7;
`

export const DividerHorizontal = styled(Divider)<IDividerHorizontal>`
  margin-top: ${({ marginTop }) => marginTop || 1.6}rem;
  margin-bottom: 0.8rem;
  background-color: #f2f3f7;
`

export const GridHeaderContact = styled(Grid)`
  display: inline-flexbox;
  padding: 0.5rem 0 0 0;
`

export const GridTitleContact = styled(Grid)`
  display: block;
  padding: 0.5rem 0 0 0;
`

export const BoxTitleContact = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.4rem;
  font-weight: 600;
  padding-bottom: 0;
`
